import type { Schema } from '@wix/wix-data-schema-types'
import { getFieldKeyForUrl } from './getFieldKeyForUrl'
import { isDbDriverCollection } from '../collections/collectionTypes'
import { isSinglesCollectionSchema } from '../../collections/collectionTypes'

const fieldKeyForUrlExists = (schema: Schema): boolean => {
  const collectionFields = Object.entries(schema.fields).map(
    ([name, field]) => ({ ...field, name }),
  )
  const fieldKeyForUrl = getFieldKeyForUrl({
    collectionFields,
    displayField: schema.displayField,
    isTPACollection: isDbDriverCollection(schema),
  })
  return !!fieldKeyForUrl
}

export const schemaSupportsDPs = (schema: Schema): boolean =>
  !isSinglesCollectionSchema(schema) && fieldKeyForUrlExists(schema)
